// extracted by mini-css-extract-plugin
export default {"badgeIcon":"_3ea9e4aa","badgeText":"_cfc00cfc"};